export default __webpack_public_path__ + "static/media/iframe.4bcc2af8.jpg";